import React from "react";

import { datadogRum } from "@datadog/browser-rum";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

import { ErrorView } from "@ps-design-system/components/ErrorView";

import NavContainer from "./containers/NavContainer";

const ErrorPage = ({ location }) => {
  return (
    <>
      <NavContainer location={location} />
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "-72px",
        }}
      >
        <ErrorView></ErrorView>
      </div>
    </>
  );
};

const ErrorBoundary = ({ children, location }) => {
  const handleError = (error, info) => {
    const renderingError = new Error(
      error.message || "An unknown error occurred",
    );
    renderingError.name = "ReactRenderingError";
    renderingError.stack = info.componentStack || "";
    renderingError.cause = error;

    datadogRum.addError(renderingError);
  };

  return (
    <ReactErrorBoundary
      fallbackRender={() => <ErrorPage location={location} />}
      onError={handleError}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export { ErrorBoundary };
